import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService, SettingsService } from '@app/_services';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor{

  constructor(
    private authService: AuthService,
    private settings: SettingsService,
  ) {}

  private ehisUrls = [this.settings.ehisUrl, '/messages/messages/receiver', 'certificates/v1/'];
  private urlsWithNoHeaders = ['/es-public/'];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req.clone();
    if (request.url.includes('/inaadress/gazetteer')) {
      return next.handle(request);
    }

    if (!request.url.includes('/users/v1/haridusportaal/jwt')) {
      request = this.addAuthToken(request);
    }

    return next.handle(request);
  }

  private addAuthToken(req: HttpRequest<any>): HttpRequest<any> {
    let request = req.clone();

    let headers = request.headers;

    if (
      this.authService.isLoggedIn()
       && !request.url.match(`${this.settings.url}/ehis/jwt`)
    ) {
      let token;
      if (this.ehisUrls.some(url => request.url.includes(url))) {
        token = sessionStorage.getItem('ehisToken');
      } else {
        token = sessionStorage.getItem('token');
      }
      headers = headers
      .set('Authorization', `Bearer ${token}`);
    }

    // for some reason extra headers kill preflight request to elasticsearch
    if (this.urlsWithNoHeaders.some(url => request.url.includes(url))) {
      headers = headers.delete('Authorization');
    } else {
      headers = headers
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache')
      .set('Expires', '-1');
    }

    request = request.clone({
      headers,
    });

    return request;
  }
}
